export default __webpack_public_path__ + "static/media/hail.eaffd15d.svg";